module.exports = __webpack_public_path__ + "img/pic_location_Kaohsiung.9fec2998.png";